class GrassSelector {
  constructor() {
    document.querySelectorAll(".grass-selector").forEach(selector => this.new_grass_selector(selector))
  }

  new_grass_selector($selector) {
    const grassModels = $selector.querySelectorAll(".model");
    const modelInfoCards = $selector.querySelectorAll(".info-list");
    const grassColorOptions = $selector.querySelectorAll(".color-option");
    const grassColorOptionRegex = /(?<=--)(.*)(?=.png)/;
    const grassModelImage = $selector.querySelector(".models-image > img");

    // Clear selection
    function clearSelector(selectorElements, selectClass) {
      selectorElements.forEach((element) => {
        if (element.classList.contains(selectClass)) {
          element.classList.remove(selectClass);
        }
      });
    }

    // Display selected model info
    function displaySelectedElementInfo(selectedElement, elementInfoCards) {
      // Display corresponding info card
      elementInfoCards.forEach((card) => {
        if (card.dataset.model != selectedElement.id) {
          card.style.display = "none";
          return;
        }
        card.style.display = "block";

        if (card.dataset.colors) {
          let colors = card.dataset.colors.split("-");
          grassColorOptions.forEach((option) => {
            // Disable all color options
            option.classList.add("disabled");
            // Display only available colors
            if (colors.includes(option.id)) {
              option.classList.remove("disabled");
            }
          });
        }
      });
    }

    // Select first model on page load
    clearSelector(grassModels, "selected");
    grassModels[0].classList.add("selected");
    displaySelectedElementInfo(grassModels[0], modelInfoCards);

    // On click, clear selection and display selected model
    grassModels.forEach((model) => {
      model.addEventListener("click", () => {
        clearSelector(grassModels, "selected");
        model.classList.add("selected");
        displaySelectedElementInfo(model, modelInfoCards);
      });
    });

    // On click, display grass in the corresponding color
    grassColorOptions.forEach((option) => {
      option.addEventListener("click", () => {
        clearSelector(grassColorOptions, "selected");
        option.classList.add("selected");

        let replaceImgSource = grassModelImage.src.replace(
          grassColorOptionRegex,
          option.id
        );
        let replaceImg = new Image();
        replaceImg.src = replaceImgSource;
        replaceImg.onload = () => {
          grassModelImage.src = replaceImgSource;
        };
      });
    });
  }
}
export default GrassSelector